<template>
    <div class="dashboard">
        <div class="stats-row">
            <div class="stat-card">
                <h3>Estabelecimentos</h3>
                <h4>{{ stats.ttestabelecimentos }}</h4>
            </div>

            <div class="stat-card">
                <h3>Coletas</h3>
                <h4>{{ stats.ttcoletas }}</h4>
            </div>

            <div class="stat-card">
                <h3>Vistorias</h3>
                <h4>{{ stats.ttvistorias }}</h4>
            </div>

            <div class="stat-card">
                <h3>Processos Aguardando</h3>
                <h4>{{ ttProcessos }}</h4>
            </div>
        </div>


        <div class="row">
            <ChartNcMensalPage class="form-item" :data="chartData" />
            <ChartColetaMensalPage class="form-item" :data="chartColetaData" />
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import ChartColetaMensalPage from './ChartColetaMensalPage.vue';
import ChartNcMensalPage from './ChartNcMensalPage.vue';

export default{
    components: {ChartNcMensalPage, ChartColetaMensalPage},
    setup(){
        const stats = ref({
            ttestabelecimentos: 0,
            ttcoletas: 0,
            ttvistorias: 0,
        });
        const chartData = ref([]);
        const chartColetaData = ref([]);
        const ttProcessos = ref(0);

        const loadStats = async () => {
            try{
                const response = await Api.genericPost('/dados/resumo_geral', {
                    idep: globalStore.idep,
                    idsim: globalStore.idsim,
                });
                stats.value = response[0];

                const req = await Api.genericPost('/dados/proc/pendentes', {
                    idep: globalStore.idep,
                    idreferencia: globalStore.idperfil
                });
                ttProcessos.value = req.length;

            }catch(error){console.error('Erro ao carregar dados de estatísticas:', error);}
        };

        const loadChartData = async () => {
            const now = new Date();
            let inicio, fim;
            try{
                inicio = new Date(now.getFullYear(), now.getMonth() -11, 1);
                fim = new Date(now.getFullYear(), now.getMonth() + 1, 0);

                const rVist = await Api.genericPost('/dados/vistoria/ttmensal', {
                    idep: globalStore.idep, 
                    idsim: globalStore.idsim,
                    datainicial: inicio.toISOString().split('T')[0], 
                    datafinal: fim.toISOString().split('T')[0]
                });

                const rVistNC = await Api.genericPost('/dados/vistoria/ttnc/mensal', {
                    idep: globalStore.idep, 
                    idsim: globalStore.idsim,
                    datainicial: inicio.toISOString().split('T')[0], 
                    datafinal: fim.toISOString().split('T')[0]
                });

                chartData.value = [
                    rVist.map(item => ({
                        x: `${item.ano}-${String(item.mes).padStart(2, '0')}`,
                        y: item.qtdd,})),
                    rVistNC.map(item => ({
                        x: `${item.ano}-${String(item.mes).padStart(2, '0')}`,
                        y: item.qtdd,})),
                    ];
            }catch (error){console.error('Erro ao carregar dados do gráfico:', error);}
        };


        const loadChartColetaData = async () => {
            const now = new Date();
            let inicio, fim;
            try{
                inicio = new Date(now.getFullYear(), now.getMonth() -11, 1);
                fim = new Date(now.getFullYear(), now.getMonth() + 1, 0);

                const rColeta = await Api.genericPost('/dados/coleta/ttmensal', {
                    idep: globalStore.idep, 
                    idsim: globalStore.idsim,
                    datainicial: inicio.toISOString().split('T')[0], 
                    datafinal: fim.toISOString().split('T')[0]
                });

                const rNcColeta = await Api.genericPost('/dados/coleta/ttnc/mensal', {
                    idep: globalStore.idep, 
                    idsim: globalStore.idsim,
                    datainicial: inicio.toISOString().split('T')[0], 
                    datafinal: fim.toISOString().split('T')[0]
                });

                chartColetaData.value = [
                    rColeta.map(item => ({
                        x: `${item.ano}-${String(item.mes).padStart(2, '0')}`,
                        y: item.qtdd,})),
                    rNcColeta.map(item => ({
                        x: `${item.ano}-${String(item.mes).padStart(2, '0')}`,
                        y: item.qtdd,})),
                    ];
            }catch (error){console.error('Erro ao carregar dados do gráfico:', error);}
        };


        onMounted(()=>{
            loadStats();
            loadChartData();
            loadChartColetaData();
        });

        return{stats, chartData, chartColetaData, ttProcessos};
    }
}
</script>